import { http } from '@/lib/ats-https';

const getApplication = async (applicationId, params) => {
  const response = await http.get(`/ats_applications/${applicationId}`, {
    params,
  });

  const { errors } = response ?? {};

  const isLinkedToUser =
    Array.isArray(errors) & errors.includes('err_application_linked_to_user');

  if (response.status === 404) {
    return {
      applicationDeleted: true,
    };
  }
  if (response.status === 403 || isLinkedToUser) {
    return {
      accessDenied: true,
    };
  }
  return response.data;
};

const getApplicationNotes = async (applicationId, params) => {
  const response = await http.get(`/ats_applications/${applicationId}/notes`, {
    params,
  });
  return response;
};

const saveApplicationNote = async (applicationId, payload) => {
  let url = `/ats_applications/${applicationId}/notes`;
  const response = await http.post(url, payload);
  return response?.data;
};

const updateApplicationNote = async (applicationId, payload, noteId) => {
  let url = `/ats_applications/${applicationId}/notes/${noteId}`;
  const response = await http.put(url, payload);
  return response?.data;
};

const getTransferredStages = async (applicationId) => {
  const response = await http.get(
    `/ats_applications/${applicationId}/transferred_stages`
  );
  return response?.data;
};

export const API_SERVICE = {
  getApplication,
  getApplicationNotes,
  saveApplicationNote,
  updateApplicationNote,
  getTransferredStages,
};
